import React, { useEffect } from 'react';
import { Paper, Button, Box, Tooltip } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import CardHeader from 'components/Card/CardHeader.jsx';
import BlueTruck from 'assets/icons/BlueTruck.svg';
import BlueTransporter from 'assets/icons/BlueTransporter.svg';
import '../../../assets/scss/ReactPOPStyles.scss';
import 'reactjs-popup/dist/index.css';
import apiCaller from 'utils/apiCallerOutstanding';
import { mappedCurrentActiveRole } from 'utils/roleMapping';
import swal from 'sweetalert';
import firebase from '../../../config/config';
import FeatureFlagEmptyState from '../../Components/FeatureFlagEmptyState';

const useStyles = makeStyles(theme => ({
  paper: { padding: '10px 20px' },
  box: {
    borderRadius: '5px',
    textAlign: 'left',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  viewButton: {
    color: '#163BAC',
    border: '1px solid #163BAC',
    textTransform: 'capitalize',
  },
  nameTabs: {
    display: 'flex',
    textAlign: 'left',
    justifyContent: 'space-between',
    marginBottom: '10px',
    alignItems: 'center',
  },
}));
const inlineCheckIconStyle = {
  marginLeft: '10px',
  color: '#52BE56',
};

const PODFileUpload = ({
  currentTransactionData,
  activeRole,
  stylesClass,
  featureFlagFiles,
}) => {
  const classes = useStyles();
  const [user, setUser] = React.useState();
  const [podData, setPodData] = React.useState({});
  const [fetching, setFetching] = React.useState(false);
  const [generateFetching, setGenerateFetching] = React.useState(false);
  const [podStatusData, setPodStatusData] = React.useState('');
  const [softPodStatusData, setSoftPodStatusData] = React.useState('');

  const [podFetching, setPodFetching] = React.useState(false);

  const {
    transactionId,
    softPodAcceptedByTransporter,
  } = currentTransactionData;

  function viewFIleUploaded(podUrl) {
    window.open(podUrl, '_blank');
  }

  const currentActiveRole = mappedCurrentActiveRole(activeRole);

  const getPodData = async token => {
    try {
      setFetching(true);

      const endPoint = `reports/v1/get_unified_pods_for_trip?role=${currentActiveRole}&transaction_id=${transactionId}`;
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      setPodData(response?.data);
    } finally {
      setFetching(false);
    }
  };

  const getPodStatus = async token => {
    setPodFetching(true);
    try {
      const endPoint = `pipe/pod-status?role=${currentActiveRole}&trip_id=${transactionId}`;
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      setPodStatusData(response?.data?.status);
      setSoftPodStatusData(response?.data?.soft_pod_status);
    } finally {
      setPodFetching(false);
    }
  };

  const generateUnifiedPod = async () => {
    setGenerateFetching(true);

    try {
      const body = {
        role: currentActiveRole,
        transaction_id: transactionId,
      };
      const endPoint = `reports/v1/generate_unified_pod_for_trip`;
      await apiCaller(endPoint, body, `Bearer ${user?.Aa}`, 'nh-base', 'post');
      await getPodData(user?.Aa);
    } catch (error) {
      swal(
        'Error!',
        error?.response?.data?.Error ||
          'Failed to generate unified POD. Please try again.',
        'error'
      );
    } finally {
      setGenerateFetching(false);
    }
  };

  const podStatusFilter = {
    traffic_queue: 'Traffic Queue',
    pod_pending: 'Pod Pending',
    inbox_hard_copy: 'Inbox Hard Copy',
    inbox_soft_copy: 'Inbox Soft Copy',
    finance_queue: 'Finance Queue',
  };

  const podStatus = podStatusFilter[podStatusData];
  const softPodStatus = podStatusFilter[softPodStatusData];

  const statusStyles = {
    traffic_queue: {
      color: '#8D7302',
      backgroundColor: '#FFF9E4',
    },
    pod_pending: {
      color: '#363636',
      backgroundColor: '#F1F2F4',
    },
    inbox_hard_copy: {
      color: '#0C60BC',
      backgroundColor: '#F3F9FF',
    },
    inbox_soft_copy: {
      color: '#0C60BC',
      backgroundColor: '#F3F9FF',
    },
    finance_queue: {
      color: '#112D83',
      backgroundColor: '#EFF2FC',
    },
  };

  const statusStyle = statusStyles[podStatusData];

  useEffect(() => {
    const userDetails = firebase.auth().currentUser;
    setUser(userDetails);
    getPodData(userDetails?.Aa);
    getPodStatus(userDetails?.Aa);
  }, [featureFlagFiles]);

  return (
    <Paper className={classes.paper}>
      {featureFlagFiles === 1 && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h3 className={stylesClass.classes.cardTitle}>POD File</h3>
        </div>
      )}
      {featureFlagFiles === 0 || featureFlagFiles === 2 ? (
        <>
          {(activeRole === 'ops' ||
            activeRole === 'finance' ||
            activeRole === 'finance-payable' ||
            activeRole === 'finance-recon' ||
            activeRole === 'sales' ||
            activeRole === 'traffic' ||
            activeRole === 'branch-ops' ||
            activeRole === 'transaction-view') && (
            <Box>
              <CardHeader
                className={`${stylesClass.classes.cardHeader}`}
                style={{
                  marginBottom: '1px',
                  padding: '0px',
                }}
              >
                <div className={classes.headerWrapper}>
                  <div className={classes.nameTabs}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <h3
                        className={`${stylesClass.classes.cardTitle} ${stylesClass.classes.rajdhaniFont}`}
                        style={{ textAlign: 'left', fontSize: '24px' }}
                      >
                        POD File
                      </h3>

                      {(podStatusData === 'approved' ||
                        softPodStatusData === 'approved') && (
                        <Tooltip
                          title={
                            podStatusData === 'approved'
                              ? 'Hard POD Approved'
                              : 'Soft POD Approved'
                          }
                        >
                          <CheckCircleIcon style={inlineCheckIconStyle} />
                        </Tooltip>
                      )}
                      {podFetching ? (
                        <CircularProgress size={15} />
                      ) : (
                        <>
                          {podStatusData !== 'approved' && (
                            <Tooltip title="Hard POD Status">
                              <p
                                style={{
                                  color: statusStyle?.color,
                                  backgroundColor: statusStyle?.backgroundColor,
                                  padding: '5px',
                                  borderRadius: '8px',
                                  margin: '0px 0px 0px 5px',
                                }}
                              >
                                {podStatus}
                              </p>
                            </Tooltip>
                          )}
                          {softPodStatusData !== 'approved' && (
                            <Tooltip title="Soft POD Status">
                              <p
                                style={{
                                  color: statusStyle?.color,
                                  backgroundColor: statusStyle?.backgroundColor,
                                  padding: '5px',
                                  borderRadius: '8px',
                                  margin: '0px 0px 0px 5px',
                                }}
                              >
                                {softPodStatus}
                              </p>
                            </Tooltip>
                          )}
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      {podData?.trucker_pod_url && (
                        <Tooltip title="View Trucker File">
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.viewButton}
                            onClick={() =>
                              viewFIleUploaded(podData?.trucker_pod_url)
                            }
                            startIcon={<img src={BlueTruck} alt="" />}
                            disabled={fetching}
                          >
                            View
                          </Button>
                        </Tooltip>
                      )}
                      {podData?.transporter_pod_url && (
                        <Tooltip title="View Transporter File">
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.viewButton}
                            onClick={() =>
                              viewFIleUploaded(podData?.transporter_pod_url)
                            }
                            startIcon={<img src={BlueTransporter} alt="" />}
                            disabled={fetching}
                          >
                            View
                          </Button>
                        </Tooltip>
                      )}
                      {(podStatusData === 'approved' ||
                        (softPodStatusData === 'approved' &&
                          softPodAcceptedByTransporter)) &&
                        podData?.trucker_pod_url === '' && (
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.viewButton}
                            onClick={() => generateUnifiedPod()}
                            startIcon={
                              generateFetching && <CircularProgress size={15} />
                            }
                            disabled={generateFetching}
                          >
                            Generate Unified POD
                          </Button>
                        )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <div>
                        {podData?.uploaded_by && (
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <p>Uploaded By:</p>
                            <p style={{ fontWeight: 700 }}>
                              {podData?.uploaded_by}
                            </p>
                            <span style={{ fontSize: '25px' }}>•</span>
                            <p>
                              {moment(podData?.uploaded_at).format(
                                'DD/MM/YYYY'
                              )}
                            </p>
                          </div>
                        )}
                        {podData?.approved_at && (
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <p>Approved By:</p>
                            <p style={{ fontWeight: 700 }}>
                              {podData?.approved_by}
                            </p>
                            <span style={{ fontSize: '25px' }}>•</span>
                            <p>
                              {moment(podData?.approved_at).format(
                                'DD/MM/YYYY'
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Box>
          )}
        </>
      ) : (
        featureFlagFiles === 1 && <FeatureFlagEmptyState color="black" />
      )}
    </Paper>
  );
};

export default PODFileUpload;
